import styled from 'styled-components'

export const Container = styled.div`
  > div {
    max-width: ${props => props.theme.maxWidth};
    margin: 0 auto;
    padding: 50px 30px;
    text-align: center;

    p {
      margin: 30px 0;
    }

    button {
      margin: 0 auto;
    }
  }
`
